export default __webpack_public_path__ + "static/media/exon_icon1.276e1d2c.jpg";